package ru.villawonka.app.presentation.screens.setup.viewmodel

import ru.villawonka.app.common.mvvm.SingleLiveEvent

sealed interface SetupUIEvent : SingleLiveEvent {

    data object Close : SetupUIEvent

}